import { checkoutShippingAddressesStyles } from "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingAddresses";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

checkoutShippingAddressesStyles.shippingAddressGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        h3[class^="TypographyStyle"] {
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            font-size: 18px;
                        `,
                        null,
                    ],
                    "minMax",
                )}
        }
    `,
};
checkoutShippingAddressesStyles.billingAddressGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        h3[class^="TypographyStyle"] {
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            font-size: 18px;
                        `,
                        null,
                    ],
                    "minMax",
                )}
        }
    `,
};
